import KoulutusmuodonEtusivu from "@/components/03-templates/KoulutusmuodonEtusivu";
import JarjestamislupaJSX from "./JarjestamislupaHTML";
import Jarjestajaluettelo from "./Jarjestajaluettelo";
import WizardContainer from "./WizardContainer";
import { getKoulutusmuodot } from "@/utils/common";
import { useIntl } from "react-intl";
import { PaikallisenTietovarastonAvain } from "@/enums";

/**
 * Hakuavaimet, joiden perusteella basedata.jsx täydentään lokaalia
 * tietovarastoa. Näiden avaimien mukaista dataa tarvitaan laajasti kyseisen
 * koulutusmuodon sivuilla.
 **/
const hakuavaimet = [
  PaikallisenTietovarastonAvain.AJALLA,
  PaikallisenTietovarastonAvain.JOISTA_LISAKSI,
  PaikallisenTietovarastonAvain.KUJALISAMAAREET,
  PaikallisenTietovarastonAvain.LUKIO_ERITYINEN_KOULUTUSTEHTAVA_UUSI,
  PaikallisenTietovarastonAvain.LUKIO_MUUT_EHDOT,
  PaikallisenTietovarastonAvain.OIKEUS_SISAOPPILAITOSMUOTOISEEN_KOULUTUKSEEN,
  "kohteet",
  "kunnat",
  "lisatietoja",
  "lupaByUuid",
  "lupaByOid",
  "maakuntakunnat",
  "maaraystyypit",
  "opetustehtavakoodisto",
  "opetustehtavat",
  "tulevatLuvat",
  "kieletOPH"
];

export default function Lukio() {
  const intl = useIntl();

  const koulutusmuoto = getKoulutusmuodot(intl).lukiokoulutus;

  return (
    <KoulutusmuodonEtusivu
      hakuavaimet={hakuavaimet}
      Jarjestajaluettelo={Jarjestajaluettelo}
      jarjestajatOtsikko={koulutusmuoto.jarjestajatOtsikko}
      JarjestamislupaJSX={JarjestamislupaJSX}
      koulutusmuoto={koulutusmuoto}
      kuvausteksti={koulutusmuoto.kuvausteksti}
      paasivunOtsikko={koulutusmuoto.paasivunOtsikko}
      WizardContainer={WizardContainer}></KoulutusmuodonEtusivu>
  );
}
